import { useEffect } from 'react';

import {
  incrementPerUserCount,
  readPerUserCount,
} from 'components/shared/side-menu/helpers/per-user-local-storage';

import { useCurrentUser } from 'hooks/api/use-current-user';

import {
  MARK_FLOATING_BUTTON_ATTENTION_MAX_OPENS,
  MARK_OPEN_COUNT_KEY_PREFIX,
} from '../mark-panel.constants';

export const useMarkFloatingButtonAttention = (
  sessionKey: string | undefined
): boolean => {
  const oktaUserId = useCurrentUser().data?.oktaUserId;

  useEffect(() => {
    if (!sessionKey || !oktaUserId) return;

    incrementPerUserCount(MARK_OPEN_COUNT_KEY_PREFIX, oktaUserId);
  }, [sessionKey, oktaUserId]);

  if (!oktaUserId) return false;

  return (
    readPerUserCount(MARK_OPEN_COUNT_KEY_PREFIX, oktaUserId) <
    MARK_FLOATING_BUTTON_ATTENTION_MAX_OPENS
  );
};
